<template>
  <div
    class="park-detail"
    v-loading="loading"
    element-loading-text="正在加载，请稍后"
  >
    <div class="park-detail-base">
      <div class="park-detail-base-img">
        <div class="swiper mySwiper2">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              class="swiper-slide"
              v-show="
                parkDetailData.pronounceImages &&
                parkDetailData.pronounceImages.length
              "
            >
              <img
                :src="imgUrl + item.filePath"
                alt=""
                @click="handleLook(parkDetailData.pronounceImages, index)"
              />
              <div class="swiper-slide-title">{{ item.fileTitle }}</div>
            </div>
            <div
              v-for="(item, index) in parkDetailData.pronounceVideos"
              :key="item.targetId"
              class="swiper-slide"
              @click="playVideos(item)"
              v-show="
                parkDetailData.pronounceVideos &&
                parkDetailData.pronounceVideos.length
              "
            >
              <img :src="imgUrl + item.thumbnail" alt="" />
              <div class="swiper-slide-icon el-icon-video-play"></div>
              <div class="swiper-slide-title">{{ item.fileTitle }}</div>
            </div>
          </div>
        </div>
        <div class="swiper mySwiper">
          <div class="swiper-wrapper">
            <el-image
              v-show="
                parkDetailData.pronounceImages &&
                parkDetailData.pronounceImages.length
              "
              v-for="(item, index) in parkDetailData.pronounceImages"
              :key="index"
              :src="imgUrl + item.filePath"
              fit="cover"
              class="swiper-slide"
            ></el-image>
            <el-image
              v-show="
                parkDetailData.pronounceVideos &&
                parkDetailData.pronounceVideos.length
              "
              v-for="(item, index) in parkDetailData.pronounceVideos"
              :key="item.targetId"
              :src="imgUrl + item.thumbnail"
              fit="cover"
              class="swiper-slide"
            ></el-image>
          </div>
          <div class="swiper-button-prev m-swiper-button" />
          <div class="swiper-button-next m-swiper-button" />
        </div>
      </div>

      <div class="park-detail-base-content">
        <div class="park-detail-base-content-price">
          <div class="park-detail-base-content-price-text">
            {{ parkDetailData.name }}
          </div>
          <!-- <div class="park-detail-base-content-price-span">
            浏览：{{ parkDetailData.statistical }}
          </div> -->
          <div class="park-detail-top-title1-r">
            <div class="park-detail-base-content-price-img" @click="goMap">
              <img
                style="width: 30px"
                src="@/assets/images/common/img10.png"
                alt=""
              />
            </div>
            <div
              v-if="
                parkDetailData.panoramaVOS &&
                parkDetailData.panoramaVOS.length == 1 &&
                parkDetailData.panoramaVOS[0].panoramaUrl
              "
              class="park-detail-base-content-price-img"
              @click="panorama(parkDetailData.panoramaVOS[0].panoramaUrl)"
            >
              <div>
                <img
                  style="width: 30px"
                  src="@/assets/images/common/img11.png"
                  alt=""
                />
                <!--              <img src="@/assets/images/common/panorama.png" alt="" />-->
              </div>

              <!-- <div>全景图</div> -->
            </div>
            <div
              class="park-detail-base-content-price-img"
              v-show="parkDetailData.parkCode"
              v-if="
                parkDetailData.panoramaVOS &&
                parkDetailData.panoramaVOS.length > 1
              "
            >
              <el-popover placement="bottom-start" width="100" trigger="click">
                <div class="panorama-box">
                  <div class="panorama-box-title">全景链接列表</div>
                  <div
                    v-for="(item, index) in parkDetailData.panoramaVOS"
                    :key="index"
                    @click="panorama(item.panoramaUrl)"
                    class="panorama-box-li"
                  >
                    <div>{{ item.panoramaName }}</div>
                    <span class="el-icon-s-promotion"></span>
                  </div>
                </div>
                <div
                  slot="reference"
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                  "
                >
                  <div>
                    <img
                      style="width: 30px"
                      src="@/assets/images/common/img11.png"
                      alt=""
                    />
                    <!--                  <img src="@/assets/images/common/panorama.png" alt="" />-->
                  </div>
                </div>
              </el-popover>
            </div>

            <div
              class="park-detail-base-content-price-img"
              v-show="
                !parkDetailData.panoramaVOS ||
                !parkDetailData.panoramaVOS.length ||
                !parkDetailData.panoramaVOS[0].panoramaUrl
              "
            >
              <div>
                <img
                  style="width: 30px"
                  src="@/assets/images/common/img12.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="park-detail-top-title3">
          <div class="park-detail-top-title3-li3">
            <div>联系人： {{ parkDetailData.person }}</div>
            <div>联系电话：{{ parkDetailData.phone }}</div>
          </div>
        </div>
        <div class="park-detail-base-content-info-content">
          <div
            class="park-detail-base-content-info"
            v-if="parkDetailData.name != '滇中新区'"
          >
            <div class="park-detail-base-content-info-key">级别</div>
            <div class="park-detail-base-content-info-value info-value-text2">
              {{
                parkDetailData.parkLevelName
                  ? parkDetailData.parkLevelName
                  : "--"
              }}
            </div>
          </div>
          <!-- <div class="park-detail-base-content-info">
            <div class="park-detail-base-content-info-key">面积</div>
            <div class="park-detail-base-content-info-value info-value-text2">
              {{
                parkDetailData.developArea
                  ? parkDetailData.developArea + "公顷"
                  : "--"
              }}
            </div>
          </div> -->
        </div>
        <div style="margin-top: 20px">
          <div class="park-detail-base-content-info-key">主导产业</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            <!-- {{
              parkDetailData.leadingIndustry
                ? parkDetailData.leadingIndustry
                : "--"
            }} -->
            <span
              v-for="(itm, inx) in parkDetailData.labels"
              :key="'labels' + inx"
            >
              {{ itm.labelName }}
              <i v-if="inx <= parkDetailData.labels.length - 2">、</i>
            </span>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div class="park-detail-base-content-info-key">简介</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.synopsis }}
          </div>
        </div>
        <div
          v-if="parkDetailData.synopsis && parkDetailData.synopsis.length > 400"
          style="
            width: 100%;
            text-align: right;
            font-size: 0.75rem;
            color: rgb(64, 158, 255);
            cursor: pointer;
          "
          @click="moreDeatile"
        >
          更多详情
        </div>

        <!-- <div style="margin-top: 20px">
          <div class="park-detail-base-content-info-key">园区简介</div>
          <div class="park-detail-base-content-info-value info-value-text3">
            {{ parkDetailData.basicSituation }}
          </div>
        </div> -->
        <!-- <div
          class="park-detail-top-title5-span title5-span2"
          v-if="parkDetailData.infrastructureName"
        >
          {{ parkDetailData.infrastructureName }}
        </div> -->
      </div>
    </div>

    <el-tabs type="border-card" v-model="activeName" class="content-tab">
      <el-tab-pane label="地块" name="地块">
        <!-- 园区地块  -->
        <park-popular-push :park-code="parkDetailData.parkCode" />
      </el-tab-pane>
      <!-- <el-tab-pane label="园区简介" name="园区简介">
      
        <div
          id="investment"
          class="park-detail-info-investment"
          v-if="activeType == 1"
        >
          <div v-if="parkDetailData.synopsis">
            <div
              class="info-content scrollbar-definition"
              v-html="parkDetailData.synopsis"
            ></div>
          </div>
          <div class="unavailable" v-else>
            <img src="@/assets/images/unavailable.png" alt="" />
          </div>
        </div>
      </el-tab-pane> -->

      <el-tab-pane label="招商政策" name="招商政策">
        <div class="other-box-l-li1" v-if="policyInfos && policyInfos.length">
          <div class="other-box-l-li-box">
            <div
              class="other-box-l-li-box-li"
              v-for="(item, index) in policyInfos"
              :key="index"
              v-show="policyInfos && policyInfos.length"
              @click="
                $router.push({
                  name: 'rtfPreview',
                  params: item,
                })
              "
            >
              <div class="other-box-l-li-box-li-l">
                <i class="iconfont icon-ico_arrowright iconfont-color"></i>
              </div>
              <div class="other-box-l-li-box-li-r">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="基础设施" name="基础设施">
        <div
          class="other-box-l-li1"
          v-if="
            parkDetailData.infrastructureList &&
            parkDetailData.infrastructureList.length
          "
        >
          <div class="other-box-r-box">
            <div
              class="other-box-r-box-li"
              v-for="(item, index) in parkDetailData.infrastructureArr"
              :key="index"
            >
              <div class="other-box-r-box-li-t">
                <img :src="item.img" alt="" />
              </div>
              <div class="other-box-r-box-li-b">
                {{ item.name }}
              </div>
            </div>
          </div>
          <!--  -->
          <div
            class="other-box-r-content"
            v-if="parkDetailData.infrastructureRemark"
          >
            <span class="other-box-r-content-tag el-icon-warning"></span>
            <span
              >备注：<span v-html="parkDetailData.infrastructureRemark"></span>
            </span>
          </div>
        </div>
        <div class="unavailable" v-else>
          <img src="@/assets/images/unavailable.png" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="周边概况" name="周边概况">
        <div class="other-box-l-li1">
          <div class="traffic-location">
            <div class="traffic-location-top">
              <div class="traffic-location-top-right">
                <div
                  v-for="(item, index) in typeList"
                  :key="index"
                  :class="[
                    'traffic-location-top-right-li',
                    factorIndex == item.value ? 'right-li-active' : '',
                  ]"
                  @click="
                    factorIndex = item.value;
                    changeFactorIndex(item.value);
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="traffic-location-map"
              v-if="
                activeName == '周边概况' && parkDetailData.defaultLevel != null
              "
            >
              <tz-map
                ref="map"
                :position="position"
                container="mapView"
                :zoom="1"
                mw="100%"
                mh="100%"
                :maxZoom="18"
              >
                <tz-toggle-map
                  :base-list="configList"
                  :is-note="true"
                  :index="1"
                  :offset="{ right: '5px', bottom: '5px' }"
                />
                <mapImage></mapImage>
              </tz-map>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="宣传资料"
        name="宣传资料"
        v-if="parkDetailData.attachmentFiles?.length"
      >
        <div
          v-if="parkDetailData.attachmentFiles?.length"
          class="park-detail-info-investment-file"
        >
          <div
            class="park-detail-info-investment-file-li"
            v-for="(item, index) of parkDetailData.attachmentFiles"
            :key="index"
            @click="previewOrDownFile(item)"
          >
            <div class="park-detail-info-investment-image-item-title">
              {{ item.fileName }}
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <video-dialog
      :visible="playVideo.show"
      :videoSrc="playVideo.src"
      :videoTitle="playVideo.title"
      @onCloseVideo="playVideo.show = false"
    />
    <el-image-viewer
      style="z-index: 9999"
      v-if="previewImage.show"
      :url-list="previewImage.urlList"
      :initial-index="previewImage.index"
      :on-close="() => (previewImage.show = false)"
    />
    <!--    </div>-->
  </div>
</template>

<script>
import ParkPlace from "@/views/park/components/ParkPlace";
import ParkPopularPush from "@/views/park/components/ParkPopularPush";
import Swiper from "swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";
import VideoDialog from "@/components/currency/videoDialog";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import {
  getParkDetail,
  policyInfo,
  getParkShp,
} from "@/api/setting/investment";
import Concert from "@/map/Convert";
import mapEvent from "@/map/mapEvent.js";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom.js";
import mapImage from "@/components/mapImage";
import { number } from "echarts";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/15 16:38
 * @Description 园区详情
 */
export default {
  name: "parkDetail",
  // props: ['parkDetailId'],
  props: {
    parkDetailId: {
      type: Number,
      default: null,
    },
  },
  components: {
    ElImageViewer,
    ParkPopularPush,
    ParkPlace,
    VideoDialog,
    mapImage,
  },
  data() {
    return {
      position: [100.264162, 25.615269],
      configList: mapConfig.configList,
      parkDetailData: {},
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      playVideo: {
        show: false,
        src: undefined,
        title: undefined,
      },
      changparkDetailId: "",
      policyInfos: [],
      policyList: [
        { title: "关于扩大对外开放积极利用外资若干措施的通知" },
        { title: "强化政策完善措施进一步提高对外开放开发水平" },
        { title: "关于进一步优化提升营商环境全面打造国际一流创新创业" },
        { title: "关于扩大对外开放积极利用外资水平的意见" },
        { title: "鼓励跨国公司总部型机构发展专项资金使用和管理方法" },
        { title: "关于扩大对外开放积极利用外资水平的意见" },
      ],

      infrastructureArr: [
        {
          name: "土地平整",
          img: require("@/assets/images/common/land.png"),
          id: "1",
        },
        {
          name: "道路",
          img: require("@/assets/images/common/road.png"),
          id: "10",
        },
        {
          name: "给水",
          img: require("@/assets/images/common/water.png"),
          id: "7",
        },
        {
          name: "雨水",
          img: require("@/assets/images/common/rain.png"),
          id: "2",
        },
        {
          name: "污水",
          img: require("@/assets/images/common/sewage.png"),
          id: "3",
        },
        {
          name: "天然气",
          img: require("@/assets/images/common/natural_gas.png"),
          id: "8",
        },
        {
          name: "供电",
          img: require("@/assets/images/common/power.png"),
          id: "6",
        },
        {
          name: "宽带",
          img: require("@/assets/images/common/broadband.png"),
          id: "9",
        },
        {
          name: "通讯",
          img: require("@/assets/images/common/communication.png"),
          id: "4",
        },
        {
          name: "供暖",
          img: require("@/assets/images/common/gn.png"),
          id: "5",
        },
      ], //基础设施
      infrastructureConfigList: [
        {
          value: "1",
          label: "土地平整",
        },
        {
          value: "2",
          label: "通雨水管线",
        },
        {
          value: "3",
          label: "通污水管线",
        },
        {
          value: "4",
          label: "通电信管道及电缆",
        },
        {
          value: "5",
          label: " 通热力管线",
        },
        {
          value: "6",
          label: "通电力管线",
        },
        {
          value: "7",
          label: "通自来水管线",
        },
        {
          value: "8",
          label: "通天然气管线",
        },
        {
          value: "9",
          label: "通有线电视线光缆",
        },
        {
          value: "10",
          label: "通道路",
        },
      ],
      previewImage: {
        show: false,
        urlList: [],
        index: 0,
      },
      info: "",
      activeType: 1,
      layerArr: layerConfig.parkDistributionLayer.layerIndex, //园区分布查询layerIndex
      layerIndex: 0, //园区分布查询起始位置
      typeList: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "行政中心",
          value: 1,
          img: require("@/assets/images/factor/jiguandanwei.png"),
        },
        {
          name: "企业",
          value: 2,
          img: require("@/assets/images/factor/qiye.png"),
        },
        {
          name: "医疗",
          value: 3,
          img: require("@/assets/images/factor/yiyuan1.png"),
        },
        {
          name: "教育",
          value: 4,
          img: require("@/assets/images/factor/xuexiao.png"),
        },
        {
          name: "生活",
          value: 5,
          img: require("@/assets/images/factor/shequchaoshi.png"),
        },
        {
          name: "交通",
          value: 6,
          img: require("@/assets/images/factor/jiaotong.png"),
        },
        {
          name: "其他",
          value: 7,
          img: require("@/assets/images/factor/qitarukudanmingxi.png"),
        },
      ],
      factorList: [], //要素列表
      markFontColor: {
        type: String,
        default: "#000",
      },
      factorIndex: null, //要素类型下标
      mapEvents: null,
      activeName: "地块", //选项卡绑定值
      loading: false,
      parkImgList: [
        {
          name: "滇中新区",
          bgc: require("@/assets/newImg/dzxq.png"),
          bgc1: "#0f57a4cc",
        },
        {
          name: "国家级开发区",
          bgc: require("@/assets/newImg/gjjkfq.png"),
          bgc1: "#a733ffcc",
        },
        {
          name: "省级开发区",
          bgc: require("@/assets/newImg/sjkfq.png"),
          bgc1: "#f66300e8",
        },
        {
          name: "其他开发区",
          bgc: require("@/assets/newImg/qtkfq.png"),
          bgc1: "#03b9cdd6",
        },
      ], //园区
      concert: undefined,
    };
  },
  created() {
    this.concert = new Concert();
  },
  mounted() {
    this.$nextTick(() => {
      this.getetial(this.parkDetailId);
    });
  },
  watch: {
    activeName: function (val) {
      if (val == "周边概况") {
        this.$nextTick(() => {
          this.mapView = this.$refs.map.tzApi;
          this.mapView.map.addInteraction(new DoubleClickZoom());
          systemConfig.mapApi = this.mapView;

          this.mapView.zoomToExtent(
            mapConfig.extent[0],
            mapConfig.extent[1],
            mapConfig.extent[2],
            mapConfig.extent[3]
          );
          this.factorIndex = 0;
          this.changeFactorIndex(0);
          this.parkData(this.parkDetailData.id);
        });
      }
    },
    factorList: {
      deep: true,
      handler(val, oldVal) {
        if (oldVal && oldVal.length) {
          oldVal.forEach((item) => {
            let str = "type" + item.type + "_" + item.id;
            this.mapView.removeVectorFeatureById(str);
          });
        }
        if (val && val.length) {
          val.forEach((item) => {
            let coordinate = [item.centerX, item.centerY];
            let img = this.typeList[item.type].img;
            this.draw(
              coordinate,
              img,
              item.name,
              "type" + item.type + "_" + item.id
            );
          });
        }
      },
    },
    parkDetailId: {
      deep: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.loading = true;
            this.getetial(val);
          });
        }
      },
    },
  },
  methods: {
    parkData(id) {
      getParkShp(id).then((res) => {
        if (res.data.success) {
          let data = res.data.data;
          let geojson = this.concert.toGeoJson(
            data,
            "geom",
            [
              "fromDataName",
              "id",
              "parkLevel",
              "lng",
              "lat",
              "fromDataId",
              "parkCode",
            ],
            4490
          );
          this.mapView.addGeojsonMapLayer(
            geojson,
            "parkActiveLayerId",
            33,
            1,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();

              let id = "parkId_" + properties.fromDataId;
              let center = [properties.lng, properties.lat];
              feature.setProperties({ id: id, center: center });
              let fillColor = "";
              if (properties.parkCode != "DZXQ") {
                let index = Number(properties.parkLevel);
                fillColor = this.parkImgList[index].bgc1;
              } else {
                fillColor = this.parkImgList[0].bgc1;
              }

              return this.mapView.setPolygonStyle(
                properties.fromDataName,
                "#28d7ff",
                fillColor,
                "#fff"
              );
            }
          );
          this.mapView.zoomToExtentByLayerId("parkActiveLayerId");
        }
      });
    },
    moreDeatile() {
      this.$router.push({
        name: "rtfPreview",
        params: {
          title: this.parkDetailData.name + "简介",
          content: this.parkDetailData.synopsis,
        },
      });
    },

    //添加影像注记
    addLayer(conf) {
      let code,
        func = conf.func,
        param = this.convert(conf.args);
      code = `this.mapView.${func}(${param})`;
      eval(code);
    },
    //周边企业打点
    draw(coordinate, img, name, id) {
      this.mapView.addVectorPoint(
        coordinate,
        name,
        img,
        { id: id },
        "#000",
        "#fff",
        20,
        [0.5, -27],
        undefined,
        "13px"
      );
    },
    skip(url) {
      if (url) {
        window.open(url);
      }
    },
    //跳转我要用地
    goMap() {
      sessionStorage.setItem(
        "parkInfoDetail",
        JSON.stringify({
          name: this.parkDetailData.name,
          parkCodeActual: this.parkDetailData.parkCodeActual,
          type: "park",
          id: this.parkDetailData.id,
        })
      );
      this.$router.push({
        path: "/needLand/indexCopy",
      });
    },
    //切换要素类型
    changeFactorIndex(index) {
      if (index == 0) {
        this.factorList = this.parkDetailData.surroundOverviewVos
          ? this.parkDetailData.surroundOverviewVos
          : [];
      } else {
        if (this.parkDetailData.surroundingMaps) {
          this.factorList = this.parkDetailData.surroundingMaps["type_" + index]
            ? this.parkDetailData.surroundingMaps["type_" + index]
            : [];
        }
      }
    },
    getetial(id) {
      (this.activeName = "地块"), //选项卡绑定值
        getParkDetail(id).then((res) => {
          this.loading = false;
          this.$emit("changeLoading");
          if (res.data.success) {
            let data = res.data.data;
            let info = ``;

            if (data.investmentPolicy) {
              let str = `<h4>招商政策</h4>`;
              info = info + str + data.investmentPolicy;
            }
            // if (data.projectSituation) {
            //   let str = `<h4>项目情况</h4>`;
            //   info = info + str + data.projectSituation;
            // }
            if (data.investmentDemand) {
              let str = `<h4>招商需求</h4>`;
              info = info + str + data.investmentDemand;
            }
            if (data.industrialChain) {
              let str = `<h4>产业链</h4>`;
              info = info + str + data.industrialChain;
            }
            if (data.talentSituation) {
              let str = `<h4>人才情况</h4>`;
              info = info + str + data.talentSituation;
            }
            if (data.landSituation) {
              let str = `<h4>用地情况</h4>`;
              info = info + str + data.landSituation;
            }
            let infrastructure = "";
            let arr = [];

            if (data.infrastructureList.length) {
              data.infrastructureList.forEach((item, index) => {
                let Iindex = this.infrastructureArr.findIndex(
                  (Iitem) => Iitem.id == item
                );
                if (Iindex != -1) {
                  arr.push(this.infrastructureArr[Iindex]);
                }
                let obj = this.infrastructureConfigList.find(
                  (inItem) => inItem.value == item
                );
                if (index == 0) {
                  infrastructure = obj.label;
                } else {
                  infrastructure = infrastructure + "，" + obj.label;
                }
              });
            }
            this.$set(data, "infrastructureArr", arr);
            this.$set(data, "infrastructureStr", infrastructure);
            this.info = info;

            this.parkDetailData = data;

            this.getPolicyInfo({
              county: data.county ? data.county : "",
              parkCode: data.parkCode ? data.parkCode : "",
            });
            if (
              (this.parkDetailData.pronounceImage &&
                this.parkDetailData.pronounceImages.length) ||
              (this.parkDetailData.pronounceVideos &&
                this.parkDetailData.pronounceVideos.length)
            ) {
              this.$nextTick(() => {
                this.setSwiper();
              });
            }
          }
        });
    },
    getPolicyInfo(params) {
      policyInfo(params).then((res) => {
        if (res.data.success) {
          this.policyInfos = res.data.data;
        }
      });
    },
    convert(args) {
      let param = args.map((item) => {
        switch (typeof item) {
          case "string":
            return `'${item}'`;
          case "object":
            return JSON.stringify(item);
          default:
            return `${item}`;
        }
      });
      return param;
    },

    getFileIconUrl(fileSuffix) {
      let iconUrl;
      switch (fileSuffix) {
        case "pdf":
          iconUrl = require("@/assets/images/common/文件-pdf.png");
          break;
        case "doc":
        case "docx":
          iconUrl = require("@/assets/images/common/文件-word.png");
          break;
        case "zip":
        case "rar":
          iconUrl = require("@/assets/images/common/文件-压缩包.png");
          break;
        case "xls":
        case "xlsx":
          iconUrl = require("@/assets/images/common/excel.png");
          break;
        default:
          iconUrl = require("@/assets/images/common/文件-其它.jpg");
      }
      return iconUrl;
    },
    setSwiper() {
      let swiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      let swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        autoplay: {
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: swiper,
        },
      });
    },
    scrollView(selector) {
      document.querySelector(selector).scrollIntoView();
    },
    previewOrDownFile(item) {
      let fileUrl = this.imgUrl + item.filePath; //所下载文件的网络地址
      const link = document.createElement("a");
      this.loading = true;
      fetch(fileUrl)
        .then((res) =>
          res
            .blob
            // window.location.href=fileUrl
            ()
        )
        .then((blob) => {
          this.loading = false;
          // 将链接地址字符内容转变成blob地址
          link.href = URL.createObjectURL(blob);
          link.download = item.fileTitle; //下载成功后保存的文件名
          document.body.appendChild(link);
          link.click();
        });

      // item.filePath = this.imgUrl + item.filePath;
      // const link = document.createElement("a");
      // let blob = new Blob([item]);
      // let urlBold = URL.createObjectURL(blob);
      // link.href = urlBold;
      // link.download = item.fileName;
      // this.$message.success("下载成功");
      // link.click();
      // window.open(this.imgUrl + url);
    },
    //查看全景
    panorama(url) {
      window.open(url);
    },
    //播放视频
    playVideos(file) {
      this.playVideo.show = true;
      this.playVideo.src =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.playVideo.title = file.fileTitle || "";
    },
    //查看图片
    handleLook(list, index) {
      this.previewImage.urlList = [];
      list.forEach((item) => {
        this.previewImage.urlList.push(this.imgUrl + item.filePath);
      });
      this.previewImage.index = index;
      this.previewImage.show = true;
    },
  },
};
</script>

<style scoped>
.park-detail {
  width: 1180px;
  /* width: calc(245px * 5 + 10px * 11); */
  margin: 0 auto;
  padding: 10px;
  background: white;
}

.park-land {
}

.park-detail-title {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #e0e0e0;
  padding: 4px 2px 4px 0;
}

.park-detail-title-text {
  font-size: 1rem;
  font-weight: 600;
  flex-grow: 1;
}

.park-detail-title-browse-count {
  font-size: 0.75rem;
  color: #8a8a8a;
  align-self: flex-end;
  flex-shrink: 0;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  height: 420px;
}

.park-detail-base-content {
  width: 50%;
  /*display: grid;*/
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px 10px;
  font-size: 0.85rem;
}

.park-detail-base-content-price-text {
  font-weight: bold;
  font-size: 1rem;
  color: #0054bb;
  display: flex;
  align-items: center;
}

.go-map {
  margin-left: 5px;
  cursor: pointer;
}

.park-detail-base-content-price-span {
  font-size: 0.75rem;
  color: #837a7a;
}

.park-detail-top-title1-r {
  display: flex;
}

.park-detail-base-content-price-img {
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #0054bb;
  font-size: 0.8rem;
  cursor: pointer;
}

.park-detail-base-content-info {
}

.park-detail-base-content-info-key {
  font-size: 0.75rem;
  color: #979595;
  /*margin-top: 10px;*/
}

.park-detail-base-content-info-value {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}

.info-value-bold {
  /*font-weight: bold;*/
}

.info-value-text1 {
  padding-top: 5px;
  font-size: 0.8rem;
  color: #292929;
  width: 100%;
  margin-top: 10px;
}

.info-value-text2 {
  padding-top: 5px;
  font-size: 0.8rem;
  color: #292929;
  width: 100%;
}

.info-value-text3 {
  padding-top: 5px;
  font-size: 0.8rem;
  color: #292929;
  width: 100%;
}

.grid-single-line {
  grid-column: 1 / -1;
}

.park-detail-info {
  margin-top: 20px;
  width: 100%;
  /* display: grid;
  grid-template-columns: 60% calc(40% - 20px);

  column-gap: 20px; */
}

.park-detail-info-content-nav {
  display: flex;
  background-color: #e4e4e4;

  cursor: pointer;
}

.park-detail-info-content-nav-li {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 1rem;
}

.active-li {
  background: #105ab5;
  color: #fff;
}

.park-detail-info-content-nav-item {
}

.park-detail-info-sub-title {
  margin-top: 20px;
  color: #495eb8;
  border-bottom: dashed 1px #e0e0e0;
  padding: 2px;
}

.info-content {
  max-height: 500px;
  overflow: auto;
  /*margin: 20px 0;*/
  margin-bottom: 20px;
  line-height: 30px;
  white-space: pre-wrap !important;
}

.park-detail-info-content {
}

.park-detail-info-investment-content {
  margin-top: 10px;
}

.park-detail-info-investment-content-table {
  width: 100%;
}

.park-detail-info-investment-content > div {
  border: solid 1px #e0e0e0;
}

.park-detail-info-investment-content-table-c1 {
  background-color: #f1f5ff;
  width: calc(100% / 6);
}

.park-detail-info-investment-content-table-key {
  padding: 4px 8px;
  text-align: center;
}

.park-detail-info-investment-content-table-value {
  color: #909090;
  padding: 4px 8px;
}

.park-detail-info-investment-video {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-video-item-thumbnail {
  width: 120px;
  height: 80px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}

.park-detail-info-investment-video-item-thumbnail-img {
  cursor: pointer;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
}

.park-detail-info-investment-video-item-thumbnail-action {
  grid-column: 2 / 3;
  grid-row: 2 /3;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  color: white;
}

.park-detail-info-investment-video-item-title {
}

.park-detail-info-investment-image {
  margin: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.park-detail-info-investment-image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.park-detail-info-investment-image-item-img {
  width: 120px;
  height: 80px;
  cursor: pointer;
}

.park-detail-info-investment-image-item-title {
}

.park-detail-info-investment-file-li {
  padding: 5px 0;
  cursor: pointer;
  color: #0a75da;
  font-size: 0.85rem;
}

.park-detail-info-investment-file {
  /*margin-top: 10px;*/
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  /*gap: 10px;*/
  /*border: solid 1px #e5e5e5;*/
}

.park-detail-info-investment-file-item-img {
  width: 80px;
  height: 80px;
  /* padding: 8px 28px; */
  box-sizing: border-box;
  /* filter: grayscale(1); */
  cursor: pointer;
}

table {
  border: solid 1px #d0d0d0;
  border-spacing: 0;
  border-collapse: collapse;
}

.park-detail-table {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  font-size: 0.95rem;
}

.park-detail-table-header {
  background-color: #e6efff;
  color: #105ab5;
  font-weight: 600;
  font-size: 1rem;
  padding: 12px;
}

.park-detail-table-key {
  width: calc(100% / 6);
  padding: 8px;
  color: #000000;
}

.park-detail-table-value {
  width: calc(100% / 6 * 2);
  color: #858585;
  padding: 8px;
}

.park-detail-table-key1 {
  width: calc(100% / 6 * 2);
  color: #000000;
  padding: 4px 8px;
}

.park-detail-table-value1 {
  width: calc(100% / 6);
  color: #858585;
  padding: 4px 8px;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 1.12rem;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: calc(100% / 7 * 5);
  width: 100%;
}

.mySwiper {
  height: calc(100% / 7 * 2);
  box-sizing: border-box;
  padding: 5px 0;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide-icon {
  position: absolute;
  color: #fff;
  font-size: 1.55rem;
}

.swiper-slide-title {
  position: absolute;
  top: 10px;
  left: 5px;
  font-size: 0.85rem;
  /* font-weight: 600; */
  color: #fff;
  padding: 3px 5px;
  border-radius: 4px;
  background: #00000059;
  /* 设置描边宽度及颜色 默认为字体内外描边 */
  /* text-stroke: 1px #fff; */
  /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
  /* -webkit-text-stroke: 1px #fff; */
}

.m-swiper-button {
  --swiper-navigation-size: 14px;
  color: white;
  background-color: #00000073;
  width: 20px;
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.other-box {
  margin-top: 20px;
  /* display: grid;
  grid-template-columns: 3fr 1fr;
  -moz-column-gap: 20px;
  column-gap: 20px; */
}

.other-box-l {
  display: flex;
  flex-direction: column;
}

.other-box-l-li-text {
  width: 200px;
  color: #495eb8;
  font-weight: 600;
  font-size: 1.12rem;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  padding: 12px 10px;
}

.other-box-l-li-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 10px 0 20px 0;
}

.other-box-l-li-box-li {
  width: 48%;
  line-height: 30px;
  display: flex;
}

.other-box-l-li-box-li1 {
  line-height: 30px;
  text-align: center;
  border: 1px solid #357ad7;
  border-radius: 4px;
}

.other-box-l-li-box-li-r {
  font-size: 0.85rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.iconfont-color {
  color: #02a3d3;
  font-size: 1.25rem;
}

.other-box-r-box {
  margin-top: 20px;
  display: flex;
}

.other-box-r-content {
  background: #ecfbff;
  color: #494949;
  /* width: max-content; */
  padding: 6px 20px 6px 10px;
  font-size: 0.8rem;
  border-radius: 15px;
  margin-top: 15px;
  border: 1px solid #ebf0f1;
}

.other-box-r-content-tag {
  color: #1a9af5 !important;
  font-size: 1rem;
  padding-right: 5px;
}

.other-box-r-box-li {
  display: flex;
  flex-direction: column;
  /* margin: auto; */
  width: 75px;
}

.other-box-r-box-li-t {
  width: 33px;
  height: 33px;
  margin: 0 auto;
}

.other-box-r-box-li-t > img {
  width: 100%;
  height: 100%;
}

.other-box-r-box-li-b {
  height: calc(100% - 43px);
  margin-top: 5px;
  font-size: 0.8rem;
  text-align: center;
  color: #504949;
}

>>> .tz-toggle-layout__warp {
  z-index: 1000 !important;
}

.park-detail-base {
  display: flex;
  column-gap: 20px;
}

.park-detail-base-img {
  width: 50%;
  /* height: 500px; */
}

.park-detail-base-content-li {
  width: 100%;
}

.park-detail-base-content-li-t {
  font-size: 0.85rem;
  font-weight: 600;
  color: #04469b;
  margin: 7px 0;
  display: flex;
}

.park-detail-base-content-li-c {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.park-detail-base-content-li-c-li {
  display: flex;
  justify-content: space-between;
  margin: 3px 0;
}

.park-li-1 {
  width: 100%;
}

.park-li-2 {
  width: calc((100% - 14px) / 2);
}

.li-1 {
  width: 100px;
  font-size: 0.8rem;
  background: #edf5fe;
  color: #393939;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-content {
  padding: 6px 0;
  text-align: center;
}

.li-2 {
  width: calc(100% - 110px);
  font-size: 0.75rem;
  border: 1px solid #edf5fe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.li-3 {
  width: calc((100% - 220px) / 2);
}

.park-detail-base-content-price {
  grid-column: 1 / -1;
  height: 50px;
  padding: 0 4px;
  /*background: linear-gradient(90deg, #9fccff, #1f42a100);*/
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.other-box-l-li2 {
  margin-top: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  /* max-height: 360px; */
}

.other-box-d {
  /* 解决瀑布流因高度改变而溢出*/
  height: 100%;
  overflow: auto;
  margin-bottom: 15px;
}

.other-box-l-li-box1 {
  column-count: 2;
  column-gap: 10px;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  width: 100%;
  padding: 10px 0 0 0;
}

.other-box-l-li-box-li-r1 {
  font-size: 0.85rem;
  margin-top: 10px;
  height: 37px;
  width: calc(100% - 20px);
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 10px;
}

.other-box-l-li-box2 {
  width: calc(100% - 20px);
  height: 425px;
  margin-left: 20px;
  /* max-height: 425px; */
  display: flex;
  margin: auto;
  justify-content: center;
}

.panorama-box {
}

.panorama-box-title {
  /* color: #363636; */
  color: #0054bb;
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 2px;
}

.panorama-box-li {
  padding: 6px 0;
  font-size: 0.8rem;
  /* border-bottom: 1px dotted #bbb3b3; */
  border-bottom: 1px dotted #8abadd;
  display: flex;
  justify-content: space-between;
  color: #0089ff;
  cursor: pointer;
  align-items: center;
}

.panorama-box-li > span {
  color: #0089ff;
}

.panorama-box-li:last-child {
  border-bottom: none;
}

.attachments {
  font-weight: 600;
  font-size: 0.85rem;
  padding-bottom: 12px;
  color: #1e63b9;
  border-bottom: 1px dashed #e5e5e5;
}

.traffic-location {
  height: 720px;
  width: 100%;
}

.traffic-location-top {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
}

.traffic-location-top-left {
  font-size: 0.95rem;
  font-weight: 600;
}

.traffic-location-top-right {
  display: flex;
  font-size: 0.85rem;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 6px 1px #eee;
}

.traffic-location-top-right-li {
  padding: 5px 10px;
  cursor: pointer;
}

.right-li-active {
  background: #3692fc;
  color: #fff;
}

.traffic-location-map {
  width: 100%;
  height: 700px;
}

.content-tab {
  margin-top: 20px;
}

::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  border: none !important;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  color: #0054bb;
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--border-card {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .el-tabs__item {
  font-weight: 600;
  font-size: 1rem;
  padding: 0 32px;
}

::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 15px 0;
}

.park-detail-top-title3 {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.park-detail-top-title3-li3 {
  width: 100%;
  padding: 10px;
  margin-right: 10px;
  display: flex;
  background: #617fd0;
  color: #ffffff;
  font-size: 0.8rem;
  align-items: center;
  text-align: right;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.park-detail-base-content-info-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.park-detail-base-content-info {
  width: 50%;
  margin-top: 20px;
}

.park-detail-top-title5-span {
  width: 100px;
  /*padding: 5px 0;*/
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 4px;
}

.title5-span2 {
  /*margin-left: 5px;*/
  background: #01ba61;
  margin-top: 30px;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  min-height: 400px;
}

.unavailable {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

>>> .el-image-viewer__img {
  width: 800px;
  height: 500px;
}
</style>
